import { loadRemote } from '@module-federation/enhanced/runtime';
import { createFileRoute } from '@tanstack/react-router';
import { Component, lazy } from 'react';
import { FeatureFlag } from '@mews-commander/enums';
import { ModalWrapper, NewModalBodyWrapper, QueryBoundary } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

const LazyComponent = lazy(
    async () =>
        loadRemote<{ default: typeof Component }>('microFrontendTemplate/ExampleComponent', {
            from: 'runtime',
        }) as Promise<{ default: typeof Component }>
);

const ExampleComponent = () => (
    <ModalWrapper>
        <NewModalBodyWrapper>
            <QueryBoundary loader="overlay">
                <LazyComponent />
            </QueryBoundary>
        </NewModalBodyWrapper>
    </ModalWrapper>
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/MicroFrontendTemplate/Template')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.microFrontendExampleEnabled);
    },
    component: ExampleComponent,
    staticData: {
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
